import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { ShiftClosingCard } from '../../components/dashboard/ShiftClosingCard';
import { useAuth } from '../../hooks/useAuth';

function DashboardPage() {
  const { userInfo } = useAuth();

  return (
    <Stack spacing={3}>
      <Stack spacing={0.5}>
        <Typography variant="h4" fontWeight={700}>
          Daily operations
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {userInfo?.brand_code?.toUpperCase() || 'MALBON'} · Keep every outlet aligned across shifts.
        </Typography>
      </Stack>

      <ShiftClosingCard />
    </Stack>
  );
}

export default DashboardPage;


